/**
 * One rule for turning a yoink's `images` entry into an <img> src.
 *
 * Two shapes live in that column:
 *   "{userId}/123-abc.jpg"   a storage path (every logged yoink)
 *   "https://…"              an absolute URL — legacy V1 rows, and the
 *                            place's own Google photo through our proxy
 *                            (the stand-in for an imported memory whose
 *                            owner has no photo of their own).
 *
 * The Google stand-in shipped 2026-08-04 as a same-origin PATH and was
 * made absolute the next day: as a path it was a THIRD shape, and the
 * nine V2 renderers, four PHP builders and all of V1 that test only
 * `startsWith('http')` fed it to the storage-URL builder and rendered a
 * 404 — visible everywhere but the two files that had been taught the
 * new rule. Leading-slash handling stays below for any row written
 * during that window that the repair migration missed.
 *
 * The rule was duplicated across five renderers before this module; keep
 * it here so a future shape is a one-file change.
 */
import * as gateway from './gateway.js';

/** An images[] entry as a usable src. */
export function imageSrc(img) {
  if (!img) return null;
  // Absolute URLs and same-origin paths are already addresses; only a
  // bare storage path needs the bucket resolved.
  if (img.startsWith('http') || img.startsWith('/')) return img;
  return gateway.getPublicUrl('yoinks', img);
}

/**
 * Is this the place's Google photo rather than the explorer's own?
 * Places policy wants the source shown wherever the photo shows, and
 * the journal shouldn't pass off a stock photo as a personal one.
 */
export function isGooglePhoto(img) {
  return typeof img === 'string' && img.includes('action=photo');
}
